import React from 'react';
export function Logo() {
  return <div className="flex items-center gap-3" data-id="element-219">
      <div className="relative" data-id="element-220">
        <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg blur-sm opacity-75" data-id="element-221"></div>
        <div className="relative bg-gradient-to-br from-purple-600 to-blue-600 rounded-lg p-2" data-id="element-222">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-223">
            <path d="M3 3L21 3L21 21L3 21L3 3Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-224" />
            <path d="M12 7L12 17M8 12L16 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-225" />
            <circle cx="12" cy="12" r="2" fill="white" data-id="element-226" />
          </svg>
        </div>
      </div>
      <div className="flex flex-col" data-id="element-227">
        <span className="font-bold text-lg text-white leading-none" data-id="element-228">
          CommerceBoost
        </span>
        <span className="text-xs text-gray-400 leading-none" data-id="element-229">
          WooCommerce Toolkit
        </span>
      </div>
    </div>;
}